module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"firstname":"First name","lastname":"Surname","email":"E-mail","description":"Notes"},"da":{"firstname":"Fornavn","lastname":"Efternavn","email":"E-mail","description":"Noter"}}')
  delete Component.options._Ctor
}
